// import { gql } from "@apollo/client"

// export const GET_AGENT_COMMISSION_PROCURED = gql`
// query getAgentCommissionProcured($options: options) {
//     getAgentCommissionProcured(options: $options) {
//         additional_agent_1_first_name
//         additional_agent_1_last_name
//         additional_agent_2_first_name
//         additional_agent_2_last_name
//         additional_agent_3_first_name
//         additional_agent_3_last_name
//         additional_agent_4_first_name
//         additional_agent_4_last_name
//         additional_agent_5_first_name
//         additional_agent_5_last_name
//         additional_agent_6_first_name
//         additional_agent_6_last_name
//         address
//         arcimedes_row_id
//         buyer_agent_1
//         buyer_agent_1_percent
//         buyer_agent_2
//         buyer_agent_2_percent
//         buyer_agent_3
//         buyer_agent_3_percent
//         buying_gross_commission
//         buying_percentage
//         city
//         close_of_escrow
//         listing_agent_1
//         listing_agent_1_percent
//         listing_agent_2
//         listing_agent_2_percent
//         listing_agent_3
//         listing_agent_3_percent
//         listing_gross_commission
//         listing_percentage
//         name
//         potential_fee
//         sold_price
//         state
//         status

//     }
// }
// `

// export const GET_AGENT_COMMISSION_PAID = gql`
// query getAgentCommissionPaild($options: options) {
//     getAgentCommissionPaild(options: $options) {
//         arcimedes_row_id
//         buying_gross_commission
//         city
//         close_of_escrow
//         first_name
//         gross_commission
//         last_name
//         listing_gross_commission
//         member_id
//         name
//         percentage
//         sold_price
//         state
//         total_fee
//     }
// }
// `

// export const GET_YEARLY_TOTAL_COMMISSIONS = gql`
// query getYearlyTotalCommission($options: options) {
//     getYearlyTotalCommission(options: $options) {
//         id
//         name
//         net_delta
//         total
//         year
//     }
// }
// `

// export const GET_AGENT_COMMISSION_BREAKDOWN_PROCURED = gql`
// query getAgentCommissionBreakdownProcured($year: Int!) {
//     getAgentCommissionBreakdownProcured(year: $year) {
//         agent_first_name
//         agent_id
//         agent_last_name
//         agent_starting_date
//         agent_termination_date
//         buying_procured_gross_fee
//         listing_procured_gross_fee
//     }
// }
// `

// export const GET_AGENT_COMMISSION_BREAKDOWN_PAID = gql`
// query getAgentCommissionBreakdownPaid($year: Int!) {
//     getAgentCommissionBreakdownPaid(year: $year) {
//         agent_first_name
//         agent_id
//         agent_last_name
//         agent_starting_date
//         agent_termination_date
//         paid_gross_fee
//         paid_net_fee
//     }
// }
// `


import { gql } from "@apollo/client"

export const GET_AGENT_COMMISSION_PROCURED = gql`
  query agentCommissionProcured($agentId: Int!, $year: Int!) {
    agentCommissionProcured(agentId: $agentId, year: $year)
  }
`;
// additional_agent_1_first_name
//         additional_agent_1_last_name
//         additional_agent_2_first_name
//         additional_agent_2_last_name
//         additional_agent_3_first_name
//         additional_agent_3_last_name
//         additional_agent_4_first_name
//         additional_agent_4_last_name
//         additional_agent_5_first_name
//         additional_agent_5_last_name
//         additional_agent_6_first_name
//         additional_agent_6_last_name
//         address
//         arcimedes_row_id
//         buyer_agent_1
//         buyer_agent_1_percent
//         buyer_agent_2
//         buyer_agent_2_percent
//         buyer_agent_3
//         buyer_agent_3_percent
//         buying_gross_commission
//         buying_percentage
//         city
//         close_of_escrow
//         listing_agent_1
//         listing_agent_1_percent
//         listing_agent_2
//         listing_agent_2_percent
//         listing_agent_3
//         listing_agent_3_percent
//         listing_gross_commission
//         listing_percentage
//         name
//         potential_fee
//         sold_price
//         state
//         status

export const GET_AGENT_COMMISSION_PAID = gql`
  query agentCommissionPaid($options: AgentOptions) {
    agentCommissionPaid(options: $options)
  }
`;
// arcimedes_row_id
//         buying_gross_commission
//         city
//         close_of_escrow
//         first_name
//         gross_commission
//         last_name
//         listing_gross_commission
//         member_id
//         name
//         percentage
//         sold_price
//         state
//         total_fee

//         TOTAL_FEE
//         ARCIMEDES_ROW_ID
//         NAME
//         CITY
//         STATE
//         SOLD_PRICE
//         CLOSE_OF_ESCROW
//         PERCENTAGE
//         MEMBER_ID
//         FIRST_NAME
//         LAST_NAME
//         GROSS_COMMISSION
//         LISTING_GROSS_COMMISSION
//         BUYING_GROSS_COMMISSION

export const GET_YEARLY_TOTAL_COMMISSIONS = gql`
 query getYearlyTotalCommission($getYearlyTotalCommissionId: Int!, $year: Int!) {
    getYearlyTotalCommission(id: $getYearlyTotalCommissionId, year: $year)
  }
`

export const GET_AGENT_COMMISSION_BREAKDOWN_PROCURED = gql`
query getAgentCommissionsBreakdownProcured($year: Int!) {
    getAgentCommissionsBreakdownProcured(year: $year) 
}
`

export const GET_AGENT_COMMISSION_BREAKDOWN_PAID = gql`
query getAgentCommissionsBreakdownPaid($year: Int!) {
    getAgentCommissionsBreakdownPaid(year: $year) 
}
`

export const GET_TEAM = gql`
  query getTeam($options: PageOptions!) {
    getTeam(options: $options) {
        first_name
        last_name
      }
    }
`;
